/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rowArg{margin-left:0!important;margin-right:0!important;height:66px!important;line-height:66px!important}"];
export { styles as styles };
